import * as React from 'react';
import TransportLetterForm from '../rental-details/TransportLetterForm';
import {ErrorResponse, ReturnalDocumentType, TransportDto} from '../api/dtos/dtos';
import {ErrorAlert} from '../common/ErrorAlert';
import furoApi from '../api/FuroApi';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import locales from "../locales";
import {openPdf} from "../utils/file-utils";

interface Props {
  returnalId: number;
  onClose: () => void;
}

interface State {
  transport?: TransportDto;
  error?: ErrorResponse;
}

class ReturnalTransportLetterEditor extends React.Component<Props, State> {

  public state: State = {};
  public readonly loadingHandler?: LoadingOverlayHandler;

  public componentDidMount(): void {
    this.reload();
  }

  public render(): React.ReactNode {
    const {error, transport} = this.state;
    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        <TransportLetterForm
          transport={transport}
          onSave={this.onFormSubmit}
          onCancel={this.props.onClose}
          onDownload={this.onDownload}
        />

        {error && <ErrorAlert style={{marginTop: '16px'}} error={error}/>}
      </>
    );
  }

  private onFormSubmit = (transport: TransportDto) => {
    const {returnalId} = this.props;
    const promise = furoApi.returns.saveTransport(returnalId, transport)
      .then(this.props.onClose)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private reload = () => {
    const {returnalId} = this.props;
    const promise = furoApi.returns.getTransport(returnalId)
      .then(this.onReloadSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onReloadSuccess = (response: TransportDto) => {
    const transport = response || {
      end: locales.start_address_default,
    };
    this.setState({
      transport,
      error: undefined,
    });
  };

  private onDownload = () => {
    const {returnalId} = this.props;
    const promise = furoApi.document.getReturnalDocument(returnalId, ReturnalDocumentType.TRANSPORT_LETTER)
      .then(openPdf)
      .then(this.props.onClose)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default ReturnalTransportLetterEditor;



// WEBPACK FOOTER //
// ./src/return-details/ReturnalTransportLetterEditor.tsx